'use client';
import { jsx } from 'react/jsx-runtime';
import { useState, useMemo } from 'react';
import 'classnames';
import '../../server-components/Table/components/HeaderCell.module.scss.js';
import Flex from '../../server-components/layout/Flex/Flex.js';
import '../../server-components/layout/Row/Row.module.scss.js';
import '../../server-components/layout/Stack/Stack.js';
import Box from '../../server-components/layout/Box/Box.js';
import '../../server-components/icons/ActivityIcon.js';
import '../../server-components/icons/ArrowDownIcon.js';
import '../../server-components/icons/ArrowDownRightCircleIcon.js';
import '../../server-components/icons/ArrowLeftAlignIcon.js';
import '../../server-components/icons/ArrowLeftIcon.js';
import '../../server-components/icons/ArrowRightAlignIcon.js';
import '../../server-components/icons/ArrowRightIcon.js';
import '../../server-components/icons/ArrowUpIcon.js';
import '../../server-components/icons/ArrowUpRightCircleIcon.js';
import '../../server-components/icons/ArrowsAngleExpandIcon.js';
import '../../server-components/icons/BankIcon.js';
import '../../server-components/icons/CheckIcon.js';
import '../../server-components/icons/ChevronDownIcon.js';
import '../../server-components/icons/ChevronRightIcon.js';
import '../../server-components/icons/ChevronUpIcon.js';
import '../../server-components/icons/CopyIcon.js';
import '../../server-components/icons/CrossIcon.js';
import '../../server-components/icons/DaiIcon.js';
import '../../server-components/icons/DownSortIcon.js';
import '../../server-components/icons/ExclamationTriangleIcon.js';
import '../../server-components/icons/ExpandKpiIcon.js';
import '../../server-components/icons/EyeIcon.js';
import '../../server-components/icons/EyeSlashIcon.js';
import '../../server-components/icons/Grid1x2Icon.js';
import '../../server-components/icons/InfoCircleIcon.js';
import '../../server-components/icons/ListIcon.js';
import '../../server-components/icons/LockIcon.js';
import '../../server-components/icons/MediumIcon.js';
import '../../server-components/icons/MoonIcon.js';
import '../../server-components/icons/PiggyBankIcon.js';
import QuestionMarkCircleIcon from '../../server-components/icons/QuestionMarkCircleIcon.js';
import '../../server-components/icons/ShieldIcon.js';
import '../../server-components/icons/SunIcon.js';
import '../../server-components/icons/UpSortIcon.js';
import '../../server-components/icons/XIcon.js';
import '../../server-components/Table/Table.module.scss.js';
import '../../server-components/Table/components/TableRow.module.scss.js';
import '../../server-components/Table/components/Pagination.module.scss.js';
import '../../server-components/Text/Text.js';
import '../../server-components/Table/components/TableCell/TableCell.module.scss.js';
import '../../server-components/Card/Card.module.scss.js';
import '../../server-components/List/List.module.scss.js';
import '../../server-components/ErrorBox/ErrorBox.module.scss.js';
import '../../server-components/InfoBox/InfoBox.module.scss.js';
import '../../server-components/KpiCard/KpiCard.module.scss.js';
import '../../server-components/TrendValue/TrendValue.module.scss.js';
import '../../server-components/Modal/Modal.module.scss.js';
import '../ThemeProvider.js';
import '../Tabs/Tabs.module.scss.js';
import '../ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../ExpandableCard/ExpandableCard.module.scss.js';
import '../ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../CopyButton/CopyButton.module.scss.js';
import 'luxon';
import '../WalletAddress/WalletAddress.module.scss.js';
import 'ethereum-blockies-base64';
import '../filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '@blockanalitica/ui';
import '../sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../FormattedCurrency/FormattedCurrency.js';
import '../FormattedPercentage/FormattedPercentage.js';
import '../CurrencyValue/CurrencyValue.module.scss.js';
import '../PercentageValue/PercentageValue.module.scss.js';
import '../DisplaySwitch/DisplaySwitch.module.scss.js';
import '../Tooltip/Tooltip.js';
import 'lodash';
import '../charts/ChartJS.js';
import '../charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../charts/BarChart/BarChart.module.scss.js';
import '../charts/LineChart/LineChart.module.scss.js';
import '../charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../Checkbox/Checkbox.module.scss.js';
import '../../server-components/Badge/Badge.module.scss.js';
import '../../server-components/HeatmapActivity/HeatmapActivity.module.scss.js';
import '../../server-components/Switch/Switch.module.scss.js';
import '../../server-components/Select/Select.module.scss.js';
import '../../server-components/pictograms/EthPictogram.js';
import '../../server-components/pictograms/EtherScanPictogram.js';
import '../../server-components/pictograms/DebankPictogram.js';
import '../../server-components/pictograms/ZapperPictogram.js';
import '../../server-components/pictograms/DaiPictogram.js';
import 'react-loading-skeleton';

const sizeMap = {
    small: 16,
    medium: 20,
    large: 24
};
const baseUrl = 'https://icons.blockanalitica.com/crypto';
const CryptoIcon = ({ name, size = 'medium', options, extension = 'svg', ...rest }) => {
    const [error, setError] = useState(null);
    const imgSize = useMemo(() => (typeof size === 'string' ? sizeMap[size] : size), [size]);
    const mergedOptions = useMemo(() => ({
        fallback: jsx(QuestionMarkCircleIcon, { size: imgSize }),
        opacity: 1,
        ...options
    }), [imgSize, options]);
    const src = useMemo(() => `${baseUrl}/${extension}/${name.toLowerCase()}.${extension}`, [name, extension]);
    if (error) {
        console.error(error);
        return (jsx(Flex, { role: "img", "aria-label": `${name} Icon`, ...rest, children: mergedOptions.fallback }));
    }
    return (jsx(Flex, { role: "img", "aria-label": `${name} Icon`, opacity: mergedOptions.opacity, ...rest, children: jsx(Box, { as: "img", alignSelf: "center", 
            //@ts-ignore
            src: src, alt: name, width: imgSize + 'px', height: imgSize + 'px', loading: "lazy", onError: () => setError(new Error()) }) }));
};

export { CryptoIcon as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
